import { Module } from '@rxdi/core';

import { CardComponent } from './card/card.component';
import { VerticalTimelineComponent } from './vertical-timeline.component';

@Module({
  components: [VerticalTimelineComponent, CardComponent],
})
export class VerticalTimelineModule {}
